import React from 'react';
import styled from 'styled-components';
import { TextVariant } from '@naf/text';
import { spacing, breakpoints, themeLight } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { Grid, GridCol } from '@naf/grid';
import { AnimateText, AnimateStatic, AnimateDynamic } from '@naf/animation';
export const SectionHeader = ({
  title,
  ingress,
  imageOrVideo,
  containImage,
  nafBranded = true,
  className
}) => {
  return /*#__PURE__*/React.createElement(Header, {
    className: className
  }, /*#__PURE__*/React.createElement(HeaderContent, null, /*#__PURE__*/React.createElement(GridCol, {
    s: "12",
    m: "12",
    l: "12",
    xl: "12"
  }, /*#__PURE__*/React.createElement(StyledAnimateTitle, {
    textProps: {
      variant: TextVariant.Giga
    }
  }, title)), (ingress || nafBranded) && /*#__PURE__*/React.createElement(IngressGridCol, {
    s: "12",
    m: "12",
    l: "10",
    xl: "7",
    hasImage: !!imageOrVideo
  }, ingress && /*#__PURE__*/React.createElement(StyledAnimateIngress, {
    delay: 600,
    textProps: {
      variant: TextVariant.Ingress
    }
  }, ingress), nafBranded && /*#__PURE__*/React.createElement(AnimateStatic, {
    delay: 600
  }, /*#__PURE__*/React.createElement(YellowLine, null))), imageOrVideo && /*#__PURE__*/React.createElement(StyledAnimateImage, {
    $containImage: containImage,
    delay: 600
  }, imageOrVideo)));
};
const Header = styled.div.withConfig({
  displayName: "SectionHeader__Header",
  componentId: "sc-agdxtv-0"
})(["background-color:", ";"], nafColor.primary.spruce);
const HeaderContent = styled(Grid).withConfig({
  displayName: "SectionHeader__HeaderContent",
  componentId: "sc-agdxtv-1"
})(["max-width:1120px;row-gap:", " !important;margin:auto;padding:0 ", ";color:", ";@media (max-width:", "){padding:0 ", ";row-gap:", " !important;}"], spacing.space24, spacing.space48, themeLight.typography.brandTextInverted, breakpoints.l, spacing.space24, spacing.space16);
const StyledAnimateTitle = styled(AnimateText).withConfig({
  displayName: "SectionHeader__StyledAnimateTitle",
  componentId: "sc-agdxtv-2"
})(["margin-top:", ";margin-bottom:0;@media (max-width:", "){line-height:1.1em;}"], spacing.space8, breakpoints.l);
const StyledAnimateIngress = styled(AnimateText).withConfig({
  displayName: "SectionHeader__StyledAnimateIngress",
  componentId: "sc-agdxtv-3"
})(["margin-bottom:", ";margin-top:0;color:", ";@media (max-width:", "){margin-bottom:", ";}"], spacing.space32, themeLight.componentColors.cta.secondary, breakpoints.m, spacing.space24);
const YellowLine = styled.div.withConfig({
  displayName: "SectionHeader__YellowLine",
  componentId: "sc-agdxtv-4"
})(["background-color:", ";width:126px;height:4px;margin-top:", ";margin-bottom:0;@media (max-width:", "){margin-top:", ";}@media (max-width:", "){margin-top:", ";}"], nafColor.signature.yellow, spacing.space24, breakpoints.l, spacing.space16, breakpoints.s, spacing.space8);
const IngressGridCol = styled(GridCol).withConfig({
  displayName: "SectionHeader__IngressGridCol",
  componentId: "sc-agdxtv-5"
})(["margin-bottom:", ";@media (max-width:", "){margin-bottom:", ";}@media (max-width:", "){margin-bottom:", ";}"], spacing.space80, breakpoints.l, ({
  hasImage
}) => hasImage ? '10px' : '72px', breakpoints.s, spacing.space56);
const StyledAnimateImage = styled(AnimateDynamic).withConfig({
  displayName: "SectionHeader__StyledAnimateImage",
  componentId: "sc-agdxtv-6"
})(["margin-bottom:", ";grid-row:2;grid-column:8/13;& > img,& > video{width:100%;max-height:600px;object-fit:", ";@media (max-width:", "){width:100%;max-height:225px;}}@media (max-width:", "){grid-row:3;grid-column:5/13;}@media (max-width:", "){grid-row:3;grid-column:1/13;}"], ({
  $containImage
}) => $containImage ? '0' : `-${spacing.space32}`, ({
  $containImage
}) => $containImage ? 'cover' : 'contain', breakpoints.m, breakpoints.l, breakpoints.s);
//# sourceMappingURL=SectionHeader.js.map